import React from 'react';

interface SignatureHTMLRendererProps {
  html: string;
  style?: React.CSSProperties;
  className?: string;
}

const SignatureHTMLRenderer: React.FC<SignatureHTMLRendererProps> = ({
  html,
  style,
  className
}) => {
  const processHTML = (htmlContent: string) => {
    // Adicionar onError e onLoad nas tags img
    return htmlContent.replace(
      /<img([^>]*)>/gi,
      (match, attributes) => {
        // Extrair src e alt dos atributos existentes
        const srcMatch = attributes.match(/src=["']([^"']*)["']/i);
        const altMatch = attributes.match(/alt=["']([^"']*)["']/i);
        const src = srcMatch ? srcMatch[1] : '';
        const alt = altMatch ? altMatch[1] : 'Imagem';
        
        // Determinar o tipo de placeholder baseado no alt
        let placeholderText = 'Imagem';
        if (alt.toLowerCase().includes('foto') || alt.toLowerCase().includes('perfil')) {
          placeholderText = 'Foto Perfil';
        } else if (alt.toLowerCase().includes('separador') || alt.toLowerCase().includes('horizontal')) {
          placeholderText = 'Separador';
        } else if (alt.toLowerCase().includes('logo')) {
          placeholderText = 'Logo';
        }
        
        // Adicionar onError e onLoad com verificações de null
        return `<img${attributes} onerror="if(this && this.nextElementSibling && this.nextElementSibling.style) { this.style.display='none'; this.nextElementSibling.style.display='flex'; }" onload="if(this && this.nextElementSibling && this.nextElementSibling.style) { this.style.display='inline'; this.nextElementSibling.style.display='none'; }"><div style="display:none; width:60px; height:60px; background-color:#f5f5f5; border:1px solid #e0e0e0; border-radius:4px; align-items:center; justify-content:center; font-size:10px; color:#666; text-align:center; flex-direction:column;"><span style="font-size:12px; color:#999;">📷</span><span>${placeholderText}</span></div>`;
      }
    );
  };

  const processedHTML = processHTML(html);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: processedHTML }}
      style={style}
      className={className}
    />
  );
};

export default SignatureHTMLRenderer;
